import { FC } from 'react';
import './MoreAboutComponent.scss';
import { MORE_ABOUT_LABELS } from './model';
import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';

const MoreAboutComponent: FC = () => {
	return (
		<div className='more-about-container'>
			<h2 className='section-title'>{MORE_ABOUT_LABELS.title}</h2>
			<p className='exhibit-content'>{MORE_ABOUT_LABELS.content}</p>
			<ButtonComponent
				text={MORE_ABOUT_LABELS.buttonText}
				onClick={() => {}}
				style={'rounded-button secondary'}
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
			/>
		</div>
	);
};

export default MoreAboutComponent;
